import { DefaultTheme } from 'styled-components';
import { colors } from 'fulogics-ui-web/dist/layout/styles/colors';

export const theme: DefaultTheme = {
    colors,
    fontSize: {
        verySmall: '10px',
        small: '12px',
        medium: '16px',
        large: '18px',
        veryLarge: '24px',
    },
};
